import { parseTemplate } from 'url-template';
import mapProduct from '~/Api/Product/mapProduct';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import Item from './Item';
import ItemErrorResponse from './ItemErrorResponse';

interface Result {
	productGroupItem: Item;
}

export default async function findItem(
	client: ApiClient,
	userId: string,
	groupId: string,
	productId: string
): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/products/{productId}');

	try {
		const request = await client.fetch(url.expand({ userId, groupId, productId }));
		const { productGroupItem } = await request.json();
		return {
			productGroupItem: new Item(mapProduct(productGroupItem.product), productGroupItem.packageSizeForSingleUnit),
		};
	} catch (error) {
		throw error instanceof ApiClientErrorResponse
			? new ItemErrorResponse(error.request, error.statusCode, error.errors)
			: error;
	}
}
